// Iconify React Icon Names
export const ICON_CLONING = 'file-icons:dna';
export const ICON_MAXI = 'bxs:flask';
export const ICON_GIGA = 'material-symbols:g-mobiledata-rounded';
export const ICON_DESIGN = 'ic:baseline-design-services';
